// extracted by mini-css-extract-plugin
export var emptyState = "_5t-d";
export var statCard = "_5t-c";
export var table = "_5t-0";
export var tableCell = "_5t-4";
export var tableCellClickable = "_5t-5 _5t-4";
export var tableCellDefault = "_5t-6 _5t-4";
export var tableCellEmpty = "_5t-8";
export var tableCellWithValue = "_5t-7";
export var tableContainer = "_5t-e";
export var tableHeaderWeight = "_5t-1";
export var tableHeaderZone = "_5t-2";
export var tableRowHeader = "_5t-3";
export var viewModeButton = "_5t-9";
export var viewModeButtonActive = "_5t-a _5t-9";
export var viewModeButtonInactive = "_5t-b _5t-9";